<app-icono-carga *ngIf="isLoading" message="Saliendo..." />
<div class="container-global">
	<div class="container-general">
		<div class="container-doc">
			<div>
				<bc-icon
					aria-hidden="true"
					name="il-process-mistake"
					aria-label="system_not_available"
					width="152px"
					class="bc-sm"
				></bc-icon>
			</div>
			<p class="center-text font-p">
				Por este medio no tienes opciones de pago disponibles para tus
				créditos
			</p>
			<h5 class="center-text">
				Hablemos sobre tu caso y las opciones de pago que tenemos para
				ti.
			</h5>
			<div class="code-error bc-mt-4">
				<p class="container-font">¡Llámanos!</p>
				<p class="cod">(604) 4025158</p>
				<p class="cod">01800093666</p>
			</div>
			<div class="container_button">
				<button
					class="bc-mt-4"
					id="alert-btn-salir"
					bc-button
					(click)="exit()"
				>
					Salir
				</button>
			</div>
		</div>
	</div>
</div>
